var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialersms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1014 0H1.89857C0.849743 0 0 0.847809 0 1.89323V12.1179C0 13.1636 0.849971 14.0112 1.89857 14.0112H3.76562L2.3417 18.9655L8.93988 14.0112H18.1017C19.15 14.0112 20 13.1634 20 12.1179V1.89323C20 0.847581 19.1498 0 18.1014 0ZM4.14849 8.37428C3.39052 8.37428 2.7757 7.76141 2.7757 7.00581C2.7757 6.24975 3.3903 5.63711 4.14849 5.63711C4.90668 5.63711 5.52104 6.24975 5.52104 7.00581C5.52104 7.76119 4.90645 8.37428 4.14849 8.37428ZM9.99988 8.37428C9.24215 8.37428 8.6271 7.76141 8.6271 7.00581C8.6271 6.24975 9.24192 5.63711 9.99988 5.63711C10.7578 5.63711 11.3724 6.24975 11.3724 7.00581C11.3724 7.76119 10.7578 8.37428 9.99988 8.37428ZM15.8515 8.37428C15.0933 8.37428 14.4787 7.76141 14.4787 7.00581C14.4787 6.24975 15.0931 5.63711 15.8515 5.63711C16.6095 5.63711 17.2241 6.24975 17.2241 7.00581C17.2241 7.76119 16.6095 8.37428 15.8515 8.37428Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialersms);
export default __webpack_public_path__ + "static/media/dialersms.bf261245.svg";
export { ForwardRef as ReactComponent };